// // tables/ReasonTable.tsx
// import React from 'react';
// import { Card } from '@components/card/card';

// interface ReasonTableProps {
//   data: any[];
//   selectedId: string | null;
//   onSelect: (id: string, code: string) => void;
//   isLoading: boolean;
//   language: string;
// }

// export const ReasonTable: React.FC<ReasonTableProps> = ({ data, selectedId, onSelect, isLoading, language }) => {
//   const isArabic = language === 'ar';

//   const getReasonTypeName = () => {
//     const firstItem = data[0];
//     if (!firstItem) return 'الأسباب';

//     if (firstItem.transactionTypeId === '24e295ae-15d7-4f85-ad43-e7cfa4f8e9ad') {
//       return 'أسباب الصرف';
//     } else if (firstItem.transactionTypeId === 'fc437ea7-caf1-46ad-85b3-9dea0c5accdb') {
//       return 'أسباب الإضافة';
//     }
//     return 'الأسباب';
//   };

//   const getBadgeColor = () => {
//     const firstItem = data[0];
//     if (!firstItem) return 'secondary';

//     if (firstItem.transactionTypeId === 'fc437ea7-caf1-46ad-85b3-9dea0c5accdb') {
//       return 'yellow';
//     } else if (firstItem.transactionTypeId === '24e295ae-15d7-4f85-ad43-e7cfa4f8e9ad') {
//       return 'blue';
//     }
//     return 'info';
//   };

//   if (isLoading) {
//     return (
//       <div className='text-center py-5'>
//         <div className='spinner-border text-primary' role='status'>
//           <span className='visually-hidden'>جاري التحميل...</span>
//         </div>
//         <p className='text-muted mt-2'>جاري تحميل الأسباب...</p>
//       </div>
//     );
//   }

//   return (
//     <Card className='mb-4'>
//       <div className='card-header d-flex justify-content-between align-items-center'>
//         <h6 className='mb-0'>
//           <i className='fas fa-list me-2'></i>
//           قائمة {getReasonTypeName()}
//         </h6>
//       </div>

//       <div className='card-body p-0'>
//         <div className='table-responsive'>
//           <table className='table table-hover mb-0'>
//             <thead className='table-light fw-bold'>
//               <tr>
//                 <th className='text-center1 small' style={{ width: '50px' }}>
//                   #
//                 </th>
//                 {/* <th className="text-center small" style={{ width: '15%' }}>كود السبب</th> */}
//                 <th className='text-center small' style={{ width: '25%' }}>
//                   اسم السبب
//                 </th>
//                 <th className='text-center small' style={{ width: '40%' }}>
//                   الوصف
//                 </th>
//                 {/* <th className="text-center small" style={{ width: '20%' }}>نوع الحركة</th> */}
//               </tr>
//             </thead>
//             <tbody>
//               {data.map((item, index) => {
//                 const isSelected = selectedId === item.id;

//                 return (
//                   <tr
//                     key={item.id}
//                     className={isSelected ? 'table-primary' : ''}
//                     style={{ cursor: 'pointer' }}
//                     onClick={() => onSelect(item.id, item.code || item.name)}
//                   >
//                     <td className='text-center align-middle'>
//                       <div className='form-check'>
//                         <input
//                           type='radio'
//                           className='form-check-input'
//                           name='reasonSelection'
//                           checked={isSelected}
//                           onChange={() => onSelect(item.id, item.code || item.name)}
//                         />
//                       </div>
//                     </td>

//                     <td className='text-center align-middle'>
//                       {isArabic ? item.name2 || item.name : item.name || item.name2}
//                     </td>

//                     <td className='text-center align-middle'>
//                       <span className='text-muted small'>
//                         {isArabic
//                           ? item.description2 || item.description || '-'
//                           : item.description || item.description2 || '-'}
//                       </span>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div className='card-footer d-flex justify-content-between align-items-center'>
//         <div className='text-muted small'>
//           عرض {data.length} من {data.length} سبب
//         </div>
//       </div>
//     </Card>
//   );
// };



// tables/ReasonTable.tsx
import React from 'react';
import { Card } from '@components/card/card';
import { useTranslation } from 'react-i18next';

interface ReasonTableProps {
  data: any[];
  selectedId: string | null;
  onSelect: (id: string, code: string) => void;
  isLoading: boolean;
  language: string;
}

export const ReasonTable: React.FC<ReasonTableProps> = ({
  data,
  selectedId,
  onSelect,
  isLoading,
  language
}) => {
  const { t } = useTranslation();
  const isArabic = language === 'ar';

  const getReasonTypeName = () => {
    const firstItem = data[0];
    if (!firstItem) return t('Reasons_GenericTitle');

    if (firstItem.transactionTypeId === '24e295ae-15d7-4f85-ad43-e7cfa4f8e9ad') {
      // صرف
      return t('Reasons_IssueTitle');
    } else if (firstItem.transactionTypeId === 'fc437ea7-caf1-46ad-85b3-9dea0c5accdb') {
      // إضافة
      return t('Reasons_ReceiptTitle');
    }
    return t('Reasons_GenericTitle');
  };

  const getBadgeColor = () => {
    const firstItem = data[0];
    if (!firstItem) return 'secondary';

    if (firstItem.transactionTypeId === 'fc437ea7-caf1-46ad-85b3-9dea0c5accdb') {
      return 'yellow';
    } else if (firstItem.transactionTypeId === '24e295ae-15d7-4f85-ad43-e7cfa4f8e9ad') {
      return 'blue';
    }
    return 'info';
  };

  if (isLoading) {
    return (
      <div className='text-center py-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>{t('Loading')}</span>
        </div>
        <p className='text-muted mt-2'>{t('LoadingReasons')}</p>
      </div>
    );
  }

  return (
    <Card className='mb-4'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        <h6 className='mb-0'>
          <i className='fas fa-list me-2'></i>
          {t('ReasonsListTitle', { reasonType: getReasonTypeName() })}
        </h6>
      </div>

      <div className='card-body p-0'>
        <div className='table-responsive'>
          <table className='table table-hover mb-0'>
            <thead className='table-light fw-bold'>
              <tr>
                <th className='text-center small' style={{ width: '50px' }}>
                  #
                </th>
                <th className='text-center small' style={{ width: '25%' }}>
                  {t('ReasonName')}
                </th>
                <th className='text-center small' style={{ width: '40%' }}>
                  {t('ReasonDescription')}
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                const isSelected = selectedId === item.id;

                return (
                  <tr
                    key={item.id}
                    className={isSelected ? 'table-primary' : ''}
                    style={{ cursor: 'pointer' }}
                    onClick={() => onSelect(item.id, item.code || item.name)}
                  >
                    <td className='text-center align-middle'>
                      <div className='form-check'>
                        <input
                          type='radio'
                          className='form-check-input'
                          name='reasonSelection'
                          checked={isSelected}
                          onChange={() => onSelect(item.id, item.code || item.name)}
                        />
                      </div>
                    </td>

                    <td className='text-center align-middle'>
                      {isArabic ? item.name2 || item.name : item.name || item.name2}
                    </td>

                    <td className='text-center align-middle'>
                      <span className='text-muted small'>
                        {isArabic
                          ? item.description2 || item.description || '-'
                          : item.description || item.description2 || '-'}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className='card-footer d-flex justify-content-between align-items-center'>
        <div className='text-muted small'>
          {t('ReasonsFooterSummary', {
            count: data.length,
            total: data.length
          })}
        </div>
      </div>
    </Card>
  );
};
